import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, DatePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "../Filters/Helper";
import CurrencyInput from "react-currency-input";
import Cleave from "cleave.js/react";

import moment from 'moment'; 
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const CreditCardTransactionAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [creditCardType, setCreditCardType] = useState("");
  const [form] = Form.useForm();
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [tenantAccountSelect, setTenantAccountSelect] = useState({
    data: [],
    loading: true,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [SalesmanCode, setSalesmanCode] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
    getAccounts();
    getCurrencies();
    getSalesmanCode();
  }, [props.data]);

  useEffect(() => {}, []);

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.transactionProcessType === 0) {
      values.transactionProcessType = null;
    }
    RequestHandler.post(`/CreditCardTransaction`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name,isActive&$filter=isActive eq true and ${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({
          data: res.value.filter((x) => x.isActive),
          loading: false,
        });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const getAccounts = () => {
    setTenantAccountSelect({
      ...tenantAccountSelect,
      loading: true,
    });
    RequestHandler.get(`/TenantAccount?$filter=isManualAccount eq true`).then(
      (response) => {
        setTenantAccountSelect({
          data: response.value,
          loading: false,
        });
      }
    );
  };

  const getSalesmanCode = () => {
    setSalesmanCode({
      ...SalesmanCode,
      loading: true,
    });
    RequestHandler.get(`/ErpLogo/GetSalesmanCodes`, [], false, {
      rawResponse: true,
    }).then((response) => {
      if (response != "") {
        setSalesmanCode({
          data: response,
          loading: false,
        });
      } else {
        setSalesmanCode({
          data: [],
          loading: false,
        });
      }
    });
  };
  const getCurrencies = () => {
    setCurrencySelect({
      data: [],
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
      form.setFieldsValue({
        ...form.getFieldValue(),
        currencyId: 1,
        installmentType: 0,
      });
    });
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="CreditCardTransactionAdd"
      initialValues={{
        remember: true,
        transactionDate: moment(),
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label="Kasa Hesabı"
            name="tenantAccountId"
            rules={[{ required: true, message: "Lütfen Kasa Hesabı seçiniz." }]}
          >
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={tenantAccountSelect.loading}
            >
              {tenantAccountSelect.data.map(
                ({
                  id,
                  name,
                  currencyId,
                  currency,
                  bankName,
                  accountNumber,
                  iban,
                }) => (
                  <Select.Option
                    key={id}
                    value={id}
                    name={name}
                    currencyId={currencyId}
                    bankName={bankName}
                    accountNumber={accountNumber}
                    iban={iban}
                  >
                    {name
                      ? `${name} (${currency})`
                      : ` ${bankName} (${
                          accountNumber ? accountNumber : iban
                        }) (${currency})`}
                  </Select.Option>
                )
              )}
            </Select>
          </Form.Item>

          <Form.Item label={"Cari Adı/ Ünvanı"} name="firmId">
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onFirmSearch}
              style={{ width: "100%" }}
              dropdownStyle={{ minWidth: "30%" }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.firmBranchNumber}
                >
                  {item.name + " (" + item.firmBranchNumber + ")"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="currencyId"
            label="Para Birimi"
            rules={[{ required: true, message: "Lütfen Para Birimi seçiniz." }]}
          >
            <Select
              defaultValue={1}
              allowClear
              showSearch
              placeholder="Seçiniz"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={currencySelect.loading}
              defaultActiveFirstOption
            >
              {currencySelect.data.map(({ id, code }) => (
                <Select.Option key={id} value={id}>
                  {code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Tutar"
            name="amount"
            rules={[{ required: true, message: "Lütfen Tutar giriniz." }]}
          >
            <CurrencyInput
              style={{ width: "100%" }}
              className="ant-input"
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  amount: name,
                });
              }}
            />
          </Form.Item>

          <Form.Item
            label="Tarih"
            name="transactionDate"
            rules={[{ required: true, message: "Lütfen Tarih seçiniz." }]}
          >
            <DatePicker
              format="DD.MM.YYYY"
              placeholder="Tarih Seçiniz"
              style={{ width: "100%" }}
              defaultValue={moment()}
            />
          </Form.Item>

          <Form.Item label="Kart Numarası" name="cardNumber">
            <Input></Input>
          </Form.Item>

          <Form.Item label="Onay Kodu" name="authCode">
            <Input />
          </Form.Item>

          <Form.Item
            label="Taksit Seçimi"
            name="installmentType"
            rules={[
              { required: true, message: "Lütfen Taksit Seçimi yapınız." },
            ]}
          >
            <Select defaultValue={0} allowClear showSearch>
              <Select.Option key={0} value={0}>
                Tek Çekim
              </Select.Option>
              <Select.Option key={1} value={1}>
                Taksitli İşlem
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Açıklama" name="description">
            <Input.TextArea rows={4} />
          </Form.Item>

          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default CreditCardTransactionAddForm;
